import { Outlet } from 'react-router';

import { PricingRouteActions } from './PricingRouteActions';
import { HeaderToolbarAndContentLayout } from 'src/common/primitives/HeaderToolbarAndContentLayout';

export function PricingLayout() {
  return (
    <HeaderToolbarAndContentLayout
      content={<Outlet />}
      actionSection={<PricingRouteActions />}
    />
  );
}
